<template>
	<div class="private-messaging">
		<template v-if="messages.length">
			<single-message v-for="message in messages" :message="message" type="private" :key="message.id" />
		</template>

		<div class="no-messages" v-else>No private messages found</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import SingleMessage from '@/components/master/room/game-access/messaging/single-message'

export default {
	name: 'private-messaging',
	props: {
		player_filter: { default: null },
		view_filter: { default: null },
	},
	computed: {
		...mapGetters([ 'master' ]),
		messages() {
			let messages = this.master.private_messages

			if (this.player_filter && this.player_filter.id) {
				messages = messages.filter((m) => {
					return (m.sender && parseInt(m.sender.id) === parseInt(this.player_filter.id)) || (m.recipient && parseInt(m.recipient.id) === parseInt(this.player_filter.id))
				})
			}
			if (this.view_filter === 'student') {
				messages = messages.filter((m) => m.sender_player && m.sender_player.student_number && m.sender_player.student_number !== "N/A")
			}

			return messages
		}
	},
	components: { SingleMessage }
}
</script>

<style lang="stylus" scoped>
@import '../../../../assets/css/variables'


.private-messaging
	height 100%
	padding-top 8px
	.no-messages
		width 100%
		margin 80px 0 0 0
		text-align center
		font-family var(--josefin)
		font-size 2rem
		text-transform uppercase
		color blue_lighter
		opacity 0.25

</style>
